import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingQrCodeGeneratorConfig } from '@/data/landingConfig/landingQrCodeGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_QrCodeGenerator } from './schemaObject';

interface Props {}
const QrCodeGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_QrCodeGenerator} />
			<LandingTemplate
				data={landingQrCodeGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelQrCodeGenerator()}
			/>
		</>
	);
};

export default QrCodeGenerator;
